import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { ReloadApp } from "../../presentation/App";
import IconWithText from "../../services/Shared/IconWithText/IconWithText";
import RenderSwal from "../../services/Shared/RenderSwal/RenderSwal";

export function SignOut() {
    const localStorageUsername = localStorage.getItem("username");

    if (localStorageUsername !== null) {
        ClientDataProvider.Logout();
        localStorage.removeItem("username");
        RenderSwal({ height: `100px` }, <ShowSignOutWarning />, () => {});
    }
}

function ShowSignOutWarning() {
    return (
        <div>
            <p>You have been signed out.</p>
            <p>
                To login again, click <strong>Reload</strong> below
            </p>
            <IconWithText
                iconSuffix={EGlyphicon.refresh}
                whenClicked={() => ReloadApp()}
                displayAsBlock={true}
            >
                Reload
            </IconWithText>
        </div>
    );
}
